const { createContext } = require("react");

const UpdateCompanyDetailsContext = createContext({});

export default UpdateCompanyDetailsContext;
